import $ from 'jquery';

$(document).ready(function() {
    function loadResources(url) {
        const contentSelector = '.resourcesListing__content';
        const $content = $(contentSelector);
        $content.addClass('loading');
        $.ajax({
            url: url,
            method: 'GET',
            success: function(response) {
                $content.html( $(response).find(contentSelector).html() );
                $content.removeClass('loading');
            }
        })
    }

    $(document).on('change', '.resourcesListing__filters select', function(e) {
        const url = $(this).val();
        loadResources(url);
    });

    $(document).on('click', '.resourcesListing__pagination a', function(e) {
        e.preventDefault();
        const url = $(this).attr('href');
        loadResources(url);
    });
})